import { Medscape } from 'www/medscape';
import { getImageServer } from 'www/utils/get-image-server';
import { getApiServer } from 'www/utils/get-api-server';
import { getSecondsFromTimeString } from 'www/utils/get-seconds-from-time-string';
import { DEFAULT_CONTROLS_SETTINGS } from './default-controls-settings';
export class VideoLoaderProxy {
    constructor(videoEl, tracking = {}) {
        this._videoEl = videoEl;
        this._tracking = tracking;
        this._player = null;
        this._apiData = null;
    }
    get API_ENDPOINT() {
        let apiServer = getApiServer();
        return `https://${apiServer}/contentservice/video/content`;
    }
    get apiData() {
        return this._apiData;
    }
    set apiData(data) {
        this._apiData = data;
    }
    get player() {
        return this._player;
    }
    set player(player) {
        this._player = player;
    }
    get videoEl() {
        return this._videoEl;
    }
    get scriptPath() {
        return `https://${getImageServer()}/medscape-promo/streaming-video-player/js/streaming-video-player.bundle.js`
    }

    get DEFAULT_CONTROLS_SETTINGS() {
        return Object.assign({}, DEFAULT_CONTROLS_SETTINGS);
    }
    get DEFAULT_PLAYER_SETTINGS() {
        let settings = this.VideoPlayer != null ? new this.VideoPlayer.PlayerSettings() : {};
        return Object.assign({}, settings);
    }
    get DEFAULT_TRACKING_SETTINGS() {
        let settings = this.VideoPlayer != null ? new this.VideoPlayer.TrackingSettings() : {};
        return Object.assign({}, settings);
    }
    get title() {
        return this.videoEl.dataset.title || document.head.querySelector('title').textContent;
    }
    get tracking() {
        return Object.assign(this.DEFAULT_TRACKING_SETTINGS, this._tracking)
    }
    set tracking(tracking = {}) {
        this._tracking = tracking;
    }
    get getDuration() {
        return getSecondsFromTimeString;
    }
    
}
